import StyledContainer, { RowCenter } from "style/styledContainer";
import styled from "styled-components";

import { ReactComponent as TwitterSvg } from "assets/svgs/Twitter.svg";
import { ReactComponent as TelegragSvg } from "assets/svgs/Telegram.svg";
import { ReactComponent as MediumSvg } from "assets/svgs/Medium.svg";
import { ReactComponent as LinktreeSvg } from "assets/svgs/Linktree.svg";
import { ReactComponent as YoutubeSvg } from "assets/svgs/Youtube.svg";

const ContactUsCom = () => {
  const openLink = (type: string) => {
    let tempLink = "";
    switch (type) {
      case "twitter":
        tempLink = "https://twitter.com/FinanceChainge";
        break;
      case "tg":
        tempLink = "https://t.me/chaingefinance";
        break;
      case "medium":
        tempLink = "https://medium.com/@chainge-finance";
        break;
      case "linktree":
        tempLink = "https://linktr.ee/Chainge.Finance";
        break;
      default:
        tempLink = "https://www.youtube.com/@ChaingeFinance";
    }
    window.open(tempLink, "_blank");
  };

  return (
    <RowCenter>
      <CardWrap onClick={() => openLink("twitter")}>
        <TwitterSvg></TwitterSvg>
      </CardWrap>
      <StyledContainer width="6px"></StyledContainer>
      <CardWrap onClick={() => openLink("tg")}>
        <TelegragSvg></TelegragSvg>
      </CardWrap>
      <StyledContainer width="6px"></StyledContainer>
      <CardWrap onClick={() => openLink("medium")}>
        <MediumSvg></MediumSvg>
      </CardWrap>
      <StyledContainer width="6px"></StyledContainer>
      <CardWrap onClick={() => openLink("linktree")}>
        <LinktreeSvg></LinktreeSvg>
      </CardWrap>
      <StyledContainer width="6px"></StyledContainer>
      <CardWrap onClick={() => openLink("youtube")}>
        <YoutubeSvg></YoutubeSvg>
      </CardWrap>
    </RowCenter>
  );
};

const CardWrap = styled(RowCenter)`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  box-shadow: 0 12px 22px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #fff;
  background-color: #fff;

  cursor: pointer;
  &:hover {
    border-color: #e24de5;
  }
`;

export default ContactUsCom;
